import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-service-ending-band',
  templateUrl: './service-ending-band.component.html',
  styleUrls: ['./service-ending-band.component.scss'],
})
export class ServiceEndingBandComponent {
  // El aviso solo se muestra si el servicio está detenido (service_stopped = true)
  // y ya se llegó a la fecha de inicio del aviso (service_stopped_since, inicio de ese día).
  showNotice: boolean =
    environment.service_stopped &&
    new Date() >= new Date(environment.service_stopped_since + 'T00:00:00');
}
